import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { customerActions } from "stores/customer/customerActions";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";

const mapStateToProps = (state) => {
  return {
    loginProfile: state.customer.loginProfile,
    rmsOnboardingData: state.jarvisRMS.rmsOnboarding,
    onestockOnboardingData: state.jarvisOnestock.onestockOnboarding,
    customerProfile: state.customer.profile,
    investmentInfo: {
      planId: state.jarvisPrime.primeOnboarding.planId,
    },
    sentimentOnboardingData : state.sentimentTracker.sentimentOnboarding,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getOnboardingDataAction: onboardingActions.getOnboardingData,
      getRMSOnboardingDataAction: jarvsiRMSOnboardingActions.getOnboardingData,
      getOnestockOnboardingAction:
        jarvsiOnestockOnboardingActions.getOnboardingData,
      getProfileDataAction: customerActions.getProfile,
      getSentimentTrackerOnboardingDataAction: sentimentTrackerOnboardingActions.getOnboardingData,    },
    dispatch
  );

const OneTimePaymentStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default OneTimePaymentStore;
